import { AfterContentChecked, AfterContentInit, AfterViewChecked, AfterViewInit, Component, ContentChild, ElementRef, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'sc-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements AfterViewInit {

  @Input()
  dismissable = false;

  @Input()
  color = 'secondary'

  @Output('dismissed')
  dismissed = new EventEmitter<any>();

  _isDismissed = false;

  @HostBinding('class.d-none')
  get isDismissed() {
    return this._isDismissed;
  }

  @ContentChild('[headline]', { static: false })
  headlineContent?: ElementRef;

  hasHeadline = true;

  hasIcon = true;

  constructor(private host: ElementRef<HTMLElement>) { }

  ngAfterViewInit(): void {
    const native = this.host.nativeElement;
    setTimeout(() => {
      this.hasHeadline = !!native.querySelector('[headline]');
      this.hasIcon = !!native.querySelector('[icon]');
    }, 0);
  }

  dismiss() {
    this._isDismissed = true;
    this.dismissed.next();
  }
}
